// external scripts
import $ from "jquery";
import Glide from 'Glide'
import videojs from 'videojs'


// import debug from 'bows';

// example of ES2015 modules loading & tree shaking
import { emptyLinks } from "./base/_links";
import { copyToClipboard } from './base/_copyToClipboard';
import { analyticsInit } from './base/_analytics';
import ajaxForm from "./_ajaxform";


// import size from "./base/_size";
// import isTouch from "./base/_isTouch";
import fitvid from "./base/_fitvid";
// import keyboardFocus from "./base/_keyboardFocus";
// import smoothScroll from "./base/_smoothScroll";
// import share from "./base/_share";
// import loadScripts from "./base/_loadScripts";
// import tracking from "./base/_tracking";
// import debugFrontend from "./base/_debugFrontend";

// const $window = $(window);
// const $document = $(document);
// const log = debug("site");
const navInit = function() {
	const searchShowClass = 'nav__search--show';
	const overlayOpenClass = 'mobile-overlay--open';

	const mobileNavTrigger = document.getElementById('mobileNavTrigger')
	const mobileOverlay = document.getElementById('mobileOverlay')
	mobileNavTrigger.addEventListener('change', function() {
		mobileOverlay.classList.toggle(overlayOpenClass)
	})

	const navSearchContainer = document.getElementById('navSearchContainer')
	const searchToggle = document.getElementById('searchToggle')
	const searchInput = document.getElementById('navSearch')

	const openSearch = function (e) {
		navSearchContainer.classList.add(searchShowClass);
		searchInput.focus();
	}

	const closeSearch = function (e) {
		navSearchContainer.classList.remove(searchShowClass);
		searchToggle.checked = false;
		searchInput.blur()
	}

	searchToggle.addEventListener('change', function(e) {
		e.target.checked ? openSearch() : closeSearch()
	})
	if (searchToggle.checked) {
		openSearch()
	}

	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && navSearchContainer.classList.contains(searchShowClass)) {
			closeSearch()
		}
	})

	window.addEventListener('resize', function() {
		// if window > 1024 and overlay is open: close nav and overlay
		setTimeout(function() {
			if (window.innerWidth > 1024 && mobileOverlay.classList.contains(overlayOpenClass)) {
				mobileNavTrigger.checked = false
				mobileOverlay.classList.remove(overlayOpenClass)
			}
		}, 250);

		setTimeout(function() {
			// if window < 1024 and nav search is open: close search
			if (window.innerWidth < 1024 && navSearchContainer.classList.contains(searchShowClass)) {
				closeSearch()
			}
		}, 250);
	}, false)
}

const tabsInit = function() {
	const tabList = document.querySelectorAll('.tabs__tab-trigger')
	const tabContentList = document.querySelectorAll('.tabs__tab-content')
	const tabLabels = document.querySelectorAll('.tabs__tab-content > label')

	Array.prototype.map.call(tabLabels, function(item) {
		// get tab index by pulling last character from label 'for' attribute; 'tab0' => 0
		const tabIndex = parseInt(item.getAttribute('for').slice(-1))
		item.addEventListener('keyup', function(e) {
			// listen for arrow keys on focused tab labels when in accordion mode to handle navigating to next/prev tab
			const {code} = e
			if ((code === 'ArrowDown' || code === 'ArrowRight') && tabIndex < tabLabels.length - 1) {
				tabLabels[tabIndex + 1].focus()
				changeTab(`tab${tabIndex + 1}`)
			} else if ((code === 'ArrowUp' || code === 'ArrowLeft') && tabIndex > 0) {
				tabLabels[tabIndex - 1].focus()
				changeTab(`tab${tabIndex - 1}`)
			}
		})
		item.addEventListener('focus', function() {
			changeTab(`tab${tabIndex}`)
		})
	})

	const changeTab = function(tabId) {
		// get tab index from tabId
		const indexString = tabId.slice(-1)
		// get corresponding tab content based on index
		const selectedTabContent = Array.prototype.filter.call(tabContentList, function(item) {
			return item.id === `tabContent${indexString}`
		})[0]
		// get the tab trigger with matching tabId and set checked
		Array.prototype.filter.call(tabList, function(item) {
			return item.id === tabId
		})[0].checked = true
		// remove active class from all tab content items
		Array.prototype.map.call(tabContentList, function(item) {
			item.classList.remove('tabs__tab-content--active')
		})
		// add active class to currently selected tab content
		selectedTabContent.classList.add('tabs__tab-content--active')
	}

	// set onclick for all tab triggers
	Array.prototype.map.call(tabList, function(item) {
		item.onclick = function() {
			changeTab(item.id)
		}
	})
}

const glideInit = function() {
	// transitions slider track height to match currently active slide's height,
	// otherwise the track will be the height of the tallest slide
	const glideHandleHeight = function() {
		const activeSlide = document.querySelector('.glide__slide--active')
		const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0
		const glideTrack = document.querySelector('.glide__track')
		const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0

		if (activeSlideHeight !== glideTrackHeight) {
			glideTrack.style.height = `${activeSlideHeight + 30}px`
		}
	}
	// set up slider
	const glideCarousel = new Glide('.glide', {
		type: 'carousel'
	})
	// run height transition after build and slide change
	glideCarousel.on('build.after', function() {
		glideHandleHeight()
	})
	glideCarousel.on('run.after', function() {
		glideHandleHeight()
	})

	glideCarousel.mount()
}

document.addEventListener('DOMContentLoaded', function() {
	document.body.addEventListener("click", function (e) {
		let target = e.target;
		while (target !== document.body && target !== null && !("modalTrigger" in target.dataset)) {
			target = target.parentNode;
		}
		if (target !== null && "modalTrigger" in target.dataset) {
			let container = target;
			while (
				container != document.body &&
				!("modalContainer" in container.dataset)
				) {
					container = container.parentNode;
			}
			/* 
			added because client wanted to split modals for when members
			are not logged in and show they need to login 
			*/
			if($('body').hasClass('logged-in')){
				if ("modalContainer" in container.dataset) {
				//	console.log(container.dataset);
					openModal(container.dataset);

				}
			} else {
				let login = {
					facebook: "",
					id: "",
					image: "",
					media: "",
					mediaType: "",
					modalContainer: "",
					resourceTypes: "",
					shareCopy: "",
					title: "",
					twitter: "",
				}
				if(document.getElementById('login--required')){
					document.getElementById('login--required').remove();
				}
				let text;
				if ( 'campaign' == document.getElementById('modal').dataset.type){
					text = `<h1 id="login--required" style="color:white;text-align:center;">Please log in to place your order.</h1>`;
				} else {
					text = `<h1 id="login--required" style="color:white;text-align:center;">Please log in to view.</h1>`;
				}
				modal.querySelector('.modal__body').insertAdjacentHTML('afterbegin', text);
				modal.querySelector('.modal__media').style.display = 'none';
				modal.querySelector('.modal__text').style.display = 'none';
				openModal(login);
			}
		}
	});

	const modal = document.getElementById('modal');
	const modalClose = modal && modal.querySelector('.modal__close');
	const modalCopyButton = document.getElementById('modalCopyText')
	const modalActiveClass = 'modal--show';

	const openModal = function(targetDataset) {
		modalClose.focus()
		const modalType = modal.dataset.type
		const mediaType = targetDataset.mediaType;

		if (modal.querySelector('.modal__media').children.length === 0) {
			const mediaElement = createMediaElement(mediaType, targetDataset)
			if ( mediaElement ) {
				modal.querySelector('.modal__media').append(mediaElement);
			}
		}

		// if the video element is present set the src of the video from the 'video' data attribute
		if (!!modal.querySelector('#modalVideo')) {
			videojs('modalVideo', {
				controls: true,
				preload: 'auto',
				fluid: true
			}).src([
				{type: "video/mp4", src: targetDataset.media}
			]);
		}

		if (modalType === 'social' || modalType === 'calendar') {
			modal.querySelector('.modal__share-copy').textContent = targetDataset.shareCopy;
			if( mediaType == 'file' ) {
				modal.querySelector('.modal__share').style.display = 'none';
				modal.querySelector('.modal__subtitle--sub').classList.add('invisible');
				modal.querySelector('.modal__share--twitter').classList.add('hide');
				modal.querySelector('.modal__share--facebook').classList.add('hide');
			} else {
				if ( targetDataset.twitter && targetDataset.facebook ) {
					modal.querySelector('.modal__share').style.display = 'block';
					modal.querySelector('.modal__subtitle--sub').classList.remove('invisible');
					modal.querySelector('.modal__share--twitter').classList.remove('hide');
					modal.querySelector('.modal__share--facebook').classList.remove('hide');
					const twitterAnchor = modal.querySelector('[data-social="twitter"]')
					const facebookAnchor = modal.querySelector('[data-social="facebook"]')
					!!twitterAnchor && (twitterAnchor.href = targetDataset.twitter)
					!!facebookAnchor && (facebookAnchor.href = targetDataset.facebook);
				} else {
					modal.querySelector('.modal__share').style.display = 'none';
					modal.querySelector('.modal__subtitle--sub').classList.add('invisible');
					modal.querySelector('.modal__share--twitter').classList.add('hide');
					modal.querySelector('.modal__share--facebook').classList.add('hide');
				}
			}
			if ( targetDataset.media ) {
				modal.querySelector('.modal__share').style.display = 'block';
				modal.querySelector('.modal__share--download').classList.remove('hide');
				modal.querySelector('a.modal__share-icon[download]').href = targetDataset.media
			} else {
				modal.querySelector('.modal__share--download').classList.add('hide');
			}
		}

		if (modalType === 'campaign') {
			modal.querySelector('#selectResource').dataset.id = targetDataset.id;
			if( mediaType !== 'audio' ) {
				modal.querySelector('.modal__share--download').classList.add('hide');
			} else {
				modal.querySelector('.modal__share--download').href = targetDataset.media;
				modal.querySelector('.modal__share--download').classList.remove('hide');
			}
			if ( targetDataset.isMember ) {
				modal.querySelector('.modal__share-items').classList.remove('hide');
			} else {
				modal.querySelector('.modal__share-items').classList.add('hide');
			}
		} else if (modalType === 'social') {
			modal.querySelector('.modal__detail').textContent = targetDataset.resourceTypes
		} else if (modalType === 'calendar') {
			modal.querySelector('.modal__detail').textContent = targetDataset.date
		}
		// set title from data attribute and add active class
		modal.querySelector('.modal__title').textContent = targetDataset.title;
		modal.querySelector('.modal__id').textContent = "https://"+window.location.hostname+"/content-to-share/?SocialResourceId="+targetDataset.id;
		modal.classList.add(modalActiveClass);
	}
	const createMediaElement = function(mediaType, targetDataset) {
		let mediaElement
		if (mediaType === 'image') {
			mediaElement = document.createElement('img');
			mediaElement.src = targetDataset.image;
			mediaElement.alt = targetDataset.title;
		} else if (mediaType === 'video') {
			// sets up video element for videojs to handle after element is appended
			mediaElement = document.createElement('video');
			mediaElement.id = 'modalVideo';
			mediaElement.classList.add('video-js');
		} else if (mediaType === 'file') {
			mediaElement = document.createElement('img');
			mediaElement.src = targetDataset.image;
			mediaElement.alt = targetDataset.title;
		} else if (mediaType === 'audio') {
			mediaElement = document.createElement('img');
			mediaElement.src = targetDataset.image;
			mediaElement.alt = targetDataset.title;
		} else if (mediaType === '' || mediaType == null) {
			mediaElement = document.createElement('img');
			mediaElement.src = '../wp-content/themes/trusted-choice/assets/img/resource-text-only.jpg';
			mediaElement.alt = 'Trusted Choice Logo';
		}
		return mediaElement
	}

	modalClose && modalClose.addEventListener('click', function() { closeModal() })
	modal && document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && modal.classList.contains(modalActiveClass)) {
			closeModal()
		}
	})

	const closeModal = function() {
		const modalMediaChild = modal.querySelector('.modal__media').children[0]
		// remove active class and reset copy button text
		modal.classList.remove(modalActiveClass)
		if (!!document.getElementById('modalVideo')) {
			videojs(document.getElementById('modalVideo')).dispose()
		}
		!!modalMediaChild && modalMediaChild.remove()
		modalCopyButton && (modalCopyButton.textContent = 'Copy Text')
	}

	modalCopyButton && modalCopyButton.addEventListener('click', function() {
		copyToClipboard('modalShareCopy')
		modalCopyButton.textContent = 'Copied!'
	})
})

const inPageNavInit = function() {
	const navItemsContainer = document.querySelector('.in-page-nav__list')
	const navItems = document.querySelectorAll('.in-page-nav__anchor')
	// each section that will correspond to an anchor in the nav item list
	const navTargets = document.querySelectorAll('[data-in-page-nav]')
	const activeClass = 'in-page-nav__anchor--active'

	if ('IntersectionObserver' in window) {
		// using intersection observer to watch if the navTargets are in the viewport
		// if the target is in the viewport onChange will be called on that target
		const observerConfig = {
			root: null,
			rootMargin: '0px',
			threshold: 0.55
		}
		const observer = new IntersectionObserver(onChange, observerConfig)
		Array.prototype.map.call(navTargets, function(item) { observer.observe(item) })

		function onChange(changes) {
			// updates the navItems active class to whichever target is currently in the viewport
			changes.map(function(change) {
				if (change.isIntersecting && change.intersectionRatio >= 0.55) {
					// gets the corresponding navItem by comparing the target id and the navItem href
					const navItem = Array.prototype.filter.call(navItems, function(item) {
						return item.href.split('#')[1] === change.target.id
					})[0]
					// remove active class from all navItems then add active class to currently selected navItem
					Array.prototype.map.call(navItems, function(item) {
						item.classList.remove(activeClass)
					})
					navItem.classList.add(activeClass)

					window.setTimeout(function() {
						if('scrollBehavior' in document.documentElement.style) {
							navItemsContainer.scrollTo({
								left: navItem.offsetLeft - 24,
								top: 0,
								behavior: 'smooth'
							})
						} else {
							navItemsContainer.scrollLeft = navItem.offSetLeft - 24
						}
					}, 1000)
				}
			})
		}
	} else {
		// if intersection observer isn't supported set up generic click listener for active class on navItems
		Array.prototype.map.call(navItems, function(item) {
			item.addEventListener('click', function() {
				Array.prototype.map.call(navItems, function(item) {
					item.classList.remove(activeClass)
				})
				item.classList.add(activeClass)
			})
		})
	}
}

const pageHeaderVideoInit = function() {
	// handles the play/pause button in page header videos
	const video = document.getElementById('pageHeaderVideo')
	const button = document.getElementById('pageHeaderPlayPause')
	const playingClass = 'page-header__play-pause--playing'
	button.addEventListener('click', function() {
		if (video.paused) {
			video.play()
			button.classList.add(playingClass)
		} else {
			video.pause()
			button.classList.remove(playingClass)
		}
	})
}

const customSelectInit = function() {
	const customSelects = document.querySelectorAll('.custom-select')
	Array.prototype.map.call(customSelects, function(select) {
		const fakeSelect = select.querySelector('.custom-select__fake')
		const nativeSelect = select.querySelector('.custom-select__native')
		const fakeSelectTrigger = fakeSelect.querySelector('.custom-select__trigger')
		const fakeSelectOptions = fakeSelect.querySelector('.custom-select__options')
		const fakeSelectOptionsList = Array.from(fakeSelectOptions.children)
		const optionsCount = fakeSelectOptionsList.length

		let optionChecked = '',
			optionHoveredIndex = -1

		fakeSelectTrigger.addEventListener('click', function() {
			toggleFakeSelect(fakeSelect, optionChecked)
		})

		const toggleFakeSelect = function(fakeSelectEl, optionChecked) {
			if (!fakeSelectEl.classList.contains('isActive')) {
				fakeSelectEl.classList.add('isActive')
				fakeSelectEl.setAttribute('aria-hidden', false)

				const optionsHeight = fakeSelectOptions.offsetHeight
				fakeSelectTrigger.style.height = `${optionsHeight + 74}px`

				if (optionChecked) {
					const optionCheckedIndex = fakeSelectOptionsList.findIndex(
						function(item) {
							return item.dataset.value === optionChecked
						}
					)
					updateFakeSelectHovered(optionCheckedIndex)
				}
				document.addEventListener('click', function(e) {
					watchClickOutside(e, fakeSelect, closeFakeSelect)
				})
				document.addEventListener('keydown', supportKeyboardNavigation)
			} else {
				closeFakeSelect(fakeSelectEl)
			}
		}

		const closeFakeSelect = function(fakeSelectEl) {
			fakeSelectEl.classList.remove('isActive')
			fakeSelectEl.setAttribute('aria-hidden', true)
			updateFakeSelectHovered(-1)
			fakeSelectTrigger.style.height = '74px'

			document.removeEventListener('click', function(e) {
				watchClickOutside(e, fakeSelect, closeFakeSelect)
			})
			document.removeEventListener('keydown', supportKeyboardNavigation)
		}

		const updateFakeSelectHovered = function(newIndex) {
			const prevOption = fakeSelectOptions.children[optionHoveredIndex]
			const option = fakeSelectOptions.children[newIndex]

			prevOption && prevOption.classList.remove('isHover')
			option && option.classList.add('isHover')

			optionHoveredIndex = newIndex
		}

		const updateFakeSelectChecked = function(value, text) {
			const prevValue = optionChecked
			const prevOptionElement = fakeSelectOptions.querySelector(`[data-value="${prevValue}"]`)
			const optionElement = fakeSelectOptions.querySelector(`[data-value="${value}"]`)

			prevOptionElement && prevOptionElement.classList.remove('isActive')
			optionElement && optionElement.classList.add('isActive')

			fakeSelectTrigger.textContent = text
			optionChecked = value
		}

		const supportKeyboardNavigation = function(e) {
			if (e.code === 'ArrowDown' && optionHoveredIndex < optionsCount - 1) {
				e.preventDefault()
				updateFakeSelectHovered(optionHoveredIndex + 1)
			}

			if (e.code === 'ArrowUp' && optionHoveredIndex > 0) {
				e.preventDefault()
				updateFakeSelectHovered(optionHoveredIndex - 1)
			}

			if (e.code === 'Enter' || e.code === 'Space') {
				e.preventDefault()
				const option = fakeSelectOptions.children[optionHoveredIndex]
				const value = option && option.dataset.value
				if (value) {
					updateNativeSelect(nativeSelect, value)
					updateFakeSelectChecked(value, option.textContent)
				}
				closeFakeSelect(fakeSelect)
			}

			(e.code === 'Escape') && closeFakeSelect(fakeSelect)
		}

		fakeSelectOptionsList.forEach(function(option, index) {
			option.addEventListener('click', function(e) {
				const value = e.currentTarget.dataset.value
				updateNativeSelect(nativeSelect, value)
				updateFakeSelectChecked(value, e.target.textContent)
				closeFakeSelect(fakeSelect)
			})

			option.addEventListener('mouseenter', function() { updateFakeSelectHovered(index) })
		})

		const updateNativeSelect = function(nativeSelectEl, newValue) {
			nativeSelectEl.value = newValue
			const matchingFakeOptionElement = fakeSelectOptions.querySelectorAll(`[data-value="${newValue}"]`)[0]

			updateFakeSelectChecked(newValue, matchingFakeOptionElement.textContent)
			if ('createEvent' in document) {
				const evt = document.createEvent("HTMLEvents")
				evt.initEvent('change', false, true)
				nativeSelectEl.dispatchEvent(evt)
			} else {
				nativeSelectEl.fireEvent('onchange')
			}
		}
	})

	const watchClickOutside = function(e, fakeSelectEl, closeFn) {
		const wasClickedOutside = !fakeSelectEl.contains(e.target)
		wasClickedOutside && closeFn(fakeSelectEl)
	}
}


class Site {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => this.ready());
		window.addEventListener('load', () => this.load());
	}

	ready() {
		// const log = debug("site:domReady");

		!!document.getElementById('mobileNavTrigger') && navInit()

		!!document.querySelector('.tabs') && tabsInit()

		!!document.querySelector('.glide') && glideInit()

		!!document.querySelector('.in-page-nav') && inPageNavInit()

		// !!document.getElementById('modal') && modalInit()

		!!document.querySelector('#pageHeaderVideo') && pageHeaderVideoInit()

		!!document.querySelector('.js-custom-select') && customSelectInit()

		// remove any these you are not using
		// tracking.init();
		// isTouch.init();
		// keyboardFocus.init();
		// smoothScroll.init();
		// share.init();
		// size.init();
		fitvid();
		// debugFrontend.init();
		// log('document.DOMContentLoaded');
		this.share();
	}

	load() {
		// const log = debug("site:windowLoad");
		// log("window.onload");
		emptyLinks();
		analyticsInit();
	}

	share() {
		$('.js-share-twitter-link').click(function(e) {
			e.preventDefault();
			var href = $(this).attr('href');
			window.open(href, "Twitter", "height=285,width=550,resizable=1");
			return false;
		});
		$('.js-share-facebook-link').click(function(e) {
			e.preventDefault();
			var href = $(this).attr('href');
			window.open(href, "Facebook", "height=269,width=550,resizable=1");
			return false;
		});
	}

}

export default new Site;
